import React, {useMemo} from 'react'
import ProfileProvider from 'components/organisms/Providers/ProfileProvider/ProfileProvider';
import constants from 'helpers/constants';
import {useAuthClientId} from 'components/organisms/Providers/AuthProvider/AuthProvider';
import {useClientGet} from 'services/client/client.hooks';
import {useProviderView} from 'helpers/hooks/utils';

const DealflowProfileProvider = (props) => {
  const clientId = useAuthClientId();

  const dataKey = 'clientId';

  const client = useClientGet({clientId}, {enabled: clientId >= 0});

  const view = useProviderView('dealflow', null, props.skipView);

  // isLoading anything, is loading something definition related
  const isLoading = props?.isLoading || client.status?.isLoading;
  const isDefinitionsLoading = props?.isDefinitionsLoading;

  const cardDefinitions = useMemo(() => [{

  }], []);

  const options = useMemo(() => ({
    cardState: {
      options: {
        name: 'dealflow',
        type: constants.appState.type.local
      }
    },
    graphState: {
      options: {
        name: 'dealflow',
        type: constants.appState.type.local
      }
    },
    assistantState: {
      options: {
        name: 'dealflow',
        type: constants.appState.type.local
      }
    },
    cardDefinitions
  }), [cardDefinitions]);

  const updaters = useMemo(() => {
    return {
    }
  }, []);

  return <ProfileProvider {...props}
                          view={view}
                          dataKey={dataKey}
                          data={client}
                          options={options}
                          updaters={updaters}
                          isDefinitionsLoading={isDefinitionsLoading}
                          isLoading={isLoading}>
    {props.children}
  </ProfileProvider>
};

DealflowProfileProvider.propTypes = {
}

export default DealflowProfileProvider;
